/**
 * Insights page shell: capped to the viewport below app chrome so overflow
 * scrolls inside the page instead of growing the document / main past the frame.
 *
 * 8rem ≈ overview title row + main padding (p-6); 7.5rem on md where the title is larger.
 */
export const INSIGHTS_SHELL_CLASSNAME =
    'bg-background-default flex max-h-[calc(100dvh-8rem)] w-full min-w-0 flex-col items-start justify-start gap-6 overflow-hidden md:max-h-[calc(100dvh-7.5rem)]';

/** Scrollable region for insight cards (header + tabs stay fixed above). */
export const INSIGHTS_SCROLL_BODY_CLASSNAME = 'flex min-h-0 w-full min-w-0 flex-1 flex-col items-start justify-start gap-3 overflow-x-hidden overflow-y-auto';
